<script setup>
import { useGetBannersStore } from "@/modules/Banner/stores/useGetBanners.store";
import AppKintzCarousel from "./partials/AppKintzCarousel.vue";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";

const getBannersStore = useGetBannersStore();
const { loadingBanners, banners } = storeToRefs(getBannersStore);

const handleFetchBanners = () => {
  getBannersStore.handleFetchBanners({
    status: 'publish',
    active: 1
  })
}

onMounted(handleFetchBanners)
</script>
<template>
  <div class="w-full flex flex-col" v-if="banners.length && !loadingBanners">
    <AppKintzCarousel :items="banners" v-if="!loadingBanners" :show-timeline="false" />
  </div>
</template>

<style scoped></style>
